import React, { useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';

import slider1 from '../assets/images/slider/1.jpg';
import slider2 from '../assets/images/slider/2.jpg';
import homeImage1 from '../assets/images/home/1-1.jpg';
import homeMobile from '../assets/images/home/mobile.png';
import homeGroup from '../assets/images/home/group.png';
import roomKingIndoor from '../assets/images/rooms/king_indoor.jpg';
import roomBunks from '../assets/images/rooms/bunks.jpg';
import roomFamily from '../assets/images/rooms/family.jpg';
import roomKingOutdoor from '../assets/images/rooms/king_outdoor.jpg';
import thumbnailKingIndoor from '../assets/images/rooms/thumbnail/king_indoor.jpg';
import thumbnailKingOutdoor from '../assets/images/rooms/thumbnail/king_outdoor.jpg';
import thumbnailFamily from '../assets/images/rooms/thumbnail/family.jpg';
import thumbnailBunks from '../assets/images/rooms/thumbnail/bunks.jpg';
import videoThumbnail from '../assets/images/home/video_thumbnail.jpg';
import pettiImage from '../assets/images/home/petti.jpg';
import loungeImage from '../assets/images/home/lounge.jpg';
import group40 from '../assets/upload/Group-40.png';
import loungeIcon from '../assets/upload/lounge.png';

import '../assets/css/secondary/style.css';
import '../assets/css/style.css';
import '../assets/css/style-core.css';
import '../assets/css/custom.css';
import '../assets/css/hotale-style-custom.css';
import '../assets/css/tourmaster-global-style-custom.css';
import '../assets/css/tourmaster-room-style-custom.css';
import '../assets/js/plugins/goodlayers-core/include/css/page-builder.css';
import '../assets/js/plugins/goodlayers-core/plugins/gdlr-custom-icon/gdlr-custom-icon.css';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sectionRef = useRef(null);
  const facilitiesRef = useRef(null);

  // Handle visibility for section animations
  useEffect(() => {
    const sectionElement = sectionRef.current;
    if (sectionElement) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(sectionElement);
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(sectionElement);

      return () => {
        if (sectionElement) {
          observer.unobserve(sectionElement);
        }
      };
    }
  }, []);

  // Handle slideshow for mobile Rooms & Bunks
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 4);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // Handle visibility for facilities section to trigger animations
  useEffect(() => {
    const facilitiesElement = facilitiesRef.current;
    if (facilitiesElement) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('animate-icons');
            }
          });
        },
        { threshold: 0.3 }
      );
      observer.observe(facilitiesElement);

      return () => {
        if (facilitiesElement) {
          observer.unobserve(facilitiesElement);
        }
      };
    }
  }, []);

  return (
    <div className="home page-template-default page page-id-15043 theme-hotale gdlr-core-body tourmaster-body woocommerce-no-js hotale-body hotale-body-front hotale-full hotale-with-sticky-navigation hotale-blockquote-style-3 gdlr-core-link-to-lightbox">
      <style>
        {`
          /* Import Yellowtail font from Google Fonts */
          @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');

          /* Font styles for "Just Steps From the Beach" */
          .gdlr-core-title-item-title.slidertitle {
            font-family: 'Yellowtail', cursive !important;
            font-style: normal !important;
            font-weight: 400 !important;
            color: rgb(255, 255, 255) !important;
            font-size: 80px !important;
            line-height: 96px !important;
          }

          /* Mobile overrides for font styles */
          @media (max-width: 767px) {
            .gdlr-core-title-item-title.slidertitle {
              font-size: 48px !important;
              line-height: 56px !important;
            }
          }

          /* Form section styling  */
          .tourmaster-room-search-form {
            display: flex;
            align-items: flex-end;
            background-color: rgba(255, 255, 255, 0);
            border-radius: 50px;
            padding: 15px 20px;
            max-width: 1010px;
            margin: 0 auto;
          }

          .tourmaster-room-search-size10,
          .tourmaster-room-size2,
          .tourmaster-room-size5,
          .tourmaster-room-size-guests {
            flex: 1;
            margin-right: 15px;
            position: relative;
          }

          .tourmaster-room-size5 {
            flex: 0.5;
          }

          .tourmaster-room-search-size4 {
            margin-left: 15px;
            display: flex;
            align-items: center;
            height: 44px;
          }

          .tourmaster-head {
            font-family: 'Poppins', sans-serif;
            font-size: 17px;
            font-weight: 600;
            color: rgb(255, 255, 255);
            margin-bottom: 5px;
          }

          .tourmaster-tail {
            font-family: 'Poppins', sans-serif;
            background-color: #f6f6f6 !important;
            color:rgb(132, 132, 132) !important;
            padding: 10px 15px;
            border-radius: 5px;
            font-size: 13px;
            font-weight: 500;
            width: 100%;
            text-align: left;
            position: relative;
            pointer-events: none;
            height: 44px;
            display: flex;
            align-items: center;
          }

          /* Dropdown arrow styling */
          .tourmaster-tail::after {
            content: '▼';
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 12px;
            color: rgb(132, 132, 132);
          }

          .tourmaster-room-search-submit {
            background-color: #585550 !important;
            color: #eeb85e !important;
            padding: 0 30px;
            border-radius: 5px;
            font-family: 'Poppins', sans-serif;
            font-size: 13px;
            font-weight: 700;
            text-transform: uppercase;
            text-decoration: none;
            transition: background-color 0.3s ease;
            height: 44px;
            line-height: 60px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            text-align: center;
          }

          .tourmaster-room-search-submit:hover {
            background-color: #d9a14e !important;
          }

          /* Responsive adjustments */
          @media (max-width: 1200px) {
            .tourmaster-room-search-form {
              flex-direction: row;
              flex-wrap: wrap;
              padding: 10px;
              gap: 10px;
            }

            .tourmaster-room-search-size10,
            .tourmaster-room-size2 {
              flex: 1;
              min-width: calc(50% - 5px);
              margin-right: 0;
              margin-bottom: 10px;
            }

            .tourmaster-room-size5 {
              flex: 0 0 calc(25% - 5px);
              min-width: 80px;
              margin-right: 0;
              margin-bottom: 0;
            }

            .tourmaster-room-size-guests {
              flex: 1;
              min-width: calc(45% - 5px);
              margin-right: 0;
              margin-bottom: 0;
            }

            .tourmaster-room-search-size4 {
              flex: 0 0 auto;
              width: auto;
              min-width: 140px;
              text-align: center;
              margin-left: 0;
              height: auto;
              margin-top: 0;
            }

            .tourmaster-room-search-submit {
              width: 100%;
              height: 44px;
              line-height: 44px;
              padding: 0 20px;
            }
          }

          /* Custom animations for content visibility */
          @keyframes fadeInLeft {
            from {
              opacity: 0;
              transform: translateX(-50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes fadeInRight {
            from {
              opacity: 0;
              transform: translateX(50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .fade-in-left {
            opacity: 0;
            animation: fadeInLeft 600ms ease-out forwards;
          }

          .fade-in-right {
            opacity: 0;
            animation: fadeInRight 600ms ease-out forwards;
          }

          .visible .fade-in-left,
          .visible .fade-in-right {
            opacity: 1;
          }

          /* Ensure visibility for animated content */
          .content-visible {
            opacity: 1 !important;
            animation: none !important;
          }

          /* Room cards layout adjustment for Desktop */
          .outer-container.bbmirissabg.desktopview .row.clearfix {
            display: flex;
            justify-content: center;
            width: 100%;
            margin: 0;
            padding: 0 15px;
            box-sizing: border-box;
          }

          .outer-container.bbmirissabg.desktopview .row.clearfix .column {
            width: 33.33%;
            padding: 0 10px;
            box-sizing: border-box;
          }

          .outer-container.bbmirissabg.desktopview .row.clearfix .column:nth-child(1) .room-block-one.height-two {
            height: auto;
            margin-bottom: 0;
          }

          .outer-container.bbmirissabg.desktopview .row.clearfix .column:nth-child(2) {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .outer-container.bbmirissabg.desktopview .row.clearfix .column:nth-child(2) .room-block-one.height-one {
            height: auto;
            margin-bottom: 0;
          }

          .outer-container.bbmirissabg.desktopview .row.clearfix .column:nth-child(3) .room-block-one.height-two {
            height: auto;
            margin-bottom: 0;
          }

          .outer-container.bbmirissabg.desktopview .row.clearfix .column .room-block-one .inner-box {
            width: 100%;
          }

          .outer-container.bbmirissabg.desktopview .row.clearfix .column .room-block-one {
            padding: 0;
          }

          /* Mobile room cards adjustments - Updated for slideshow */
          @media (max-width: 767px) {
            .outer-container.bbmirissabg.allphone .row.clearfix {
              flex-direction: column;
              padding: 0 15px;
              width: 100%;
              max-width: 100%;
            }

            .outer-container.bbmirissabg.allphone .row.clearfix .column {
              width: 100%;
              padding: 0;
              margin-bottom: 20px;
            }

            .outer-container.bbmirissabg.allphone .row.clearfix .column:last-child {
              margin-bottom: 0;
            }

            .outer-container.bbmirissabg.allphone .row.clearfix .column .room-block-one {
              padding: 0;
            }

            .outer-container.bbmirissabg.allphone .row.clearfix .column .room-block-one .inner-box {
              width: 100%;
            }
          }

          /* Updated Mobile slideshow adjustments */
          @media (max-width: 767px) {
            .tourmaster-room-item .slides {
              display: flex;
              overflow-x: hidden;
              scroll-snap-type: x mandatory;
              -webkit-overflow-scrolling: touch;
              scrollbar-width: none; /* Firefox */
              -ms-overflow-style: none; /* IE and Edge */
              position: relative;
              width: 100%;
              transition: transform 0.5s ease-in-out;
            }

            .tourmaster-room-item .slides::-webkit-scrollbar {
              display: none; /* Chrome, Safari, Opera */
            }

            .tourmaster-room-item .slides li {
              flex: 0 0 300px; /* Fixed width for each card */
              height: 450px; /* Fixed height for each card */
              scroll-snap-align: center;
              margin-right: 15px;
              opacity: 0;
              transition: opacity 0.5s ease-in-out;
            }

            .tourmaster-room-item .slides li.active {
              opacity: 1;
            }

            .tourmaster-room-item .slides li:last-child {
              margin-right: 0;
            }

            .tourmaster-room-grid2 {
              width: 300px;
              height: 450px;
            }

            .tourmaster-room-grid-inner {
              height: 100%;
            }

            .tourmaster-room-thumbnail img {
              width: 100%;
              height: 200px;
              object-fit: cover;
            }

            .tourmaster-room-content-wrap {
              height: calc(100% - 200px);
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              padding: 15px;
            }

            .tourmaster-room-title a {
              font-size: 18px !important;
            }

            .tourmaster-info-wrap {
              margin: 10px 0;
            }

            .tourmaster-bottom {
              margin-top: auto;
            }
          }

          /* Hotel Facilities animation fixes */
          .gdlr-core-pbf-column-content[data-gdlr-animation="fadeInUp"],
          .gdlr-core-pbf-column-content[data-gdlr-animation="fadeInDown"] {
            opacity: 0;
            transition: opacity 0.3s ease, transform 0.6s ease;
          }

          .animate-icons .gdlr-core-pbf-column-content[data-gdlr-animation="fadeInUp"] {
            animation: fadeInUp 600ms ease-out forwards;
            opacity: 1;
          }

          .animate-icons .gdlr-core-pbf-column-content[data-gdlr-animation="fadeInDown"] {
            animation: fadeInDown 600ms ease-out forwards;
            opacity: 1;
          }
        `}
      </style>

      <Navbar />
      <main>
        <div className="hotale-page-wrapper" id="hotale-page-wrapper">
          <div className="gdlr-core-page-builder-body">
            <div className="gdlr-core-pbf-wrapper" style={{ padding: '150px 0px 30px 0px' }} id="gdlr-core-wrapper-1">
              <div className="gdlr-core-pbf-background-wrap">
                <div
                  className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js desktopview"
                  style={{ backgroundImage: `url(${slider1})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                  data-parallax-speed="0"
                ></div>
                <div
                  className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js allphone"
                  style={{ backgroundImage: `url(${slider2})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                  data-parallax-speed="0"
                ></div>
              </div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-1">
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js"
                      style={{ margin: '0px 40px 0px 40px', padding: '180px 0px 240px 0px' }}
                    >
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font slidertitle">
                                <br />
                                Just Steps From the Beach
                                <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first"
                    data-skin="White Input"
                    id="gdlr-core-column-3"
                  >
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '0px 0px 30px 0px' }}>
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js" style={{ maxWidth: '1010px' }}>
                        <div className="gdlr-core-pbf-element">
                          <div className="tourmaster-room-search-item tourmaster-item-pdlr clearfix">
                            <div
                              className="tourmaster-room-search-form tourmaster-radius-round tourmaster-style-text-top tourmaster-align-horizontal"
                            >
                              <div className="tourmaster-room-search-size10">
                                <div className="tourmaster-head">Check In</div>
                                <div className="tourmaster-tail">MAY 26, 2025</div>
                              </div>
                              <div className="tourmaster-room-size2">
                                <div className="tourmaster-head">Check Out</div>
                                <div className="tourmaster-tail">JUL 29, 2022</div>
                              </div>
                              <div className="tourmaster-room-size5">
                                <div className="tourmaster-head">Room</div>
                                <div className="tourmaster-tail">1</div>
                              </div>
                              <div className="tourmaster-room-size-guests">
                                <div className="tourmaster-head">Guests</div>
                                <div className="tourmaster-tail">ADULTS 2 CHILDREN 0</div>
                              </div>
                              <div className="tourmaster-room-search-size4 tourmaster-room-search-submit-wrap">
                                <a className="tourmaster-room-search-submit tourmaster-style-solid" href='https://live.ipms247.com/booking/book-rooms-bananabunksmirissa'>Search Room</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`gdlr-core-pbf-wrapper ${isVisible ? 'visible' : ''}`}
              style={{ padding: '105px 0px 36px 0px' }}
              id="gdlr-core-wrapper-2"
              ref={sectionRef}
            >
              <div className="gdlr-core-pbf-background-wrap bbmirissabg"></div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div className="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first" id="gdlr-core-column-2">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '30px 0px 0px 0px' }}>
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div
                        className={`gdlr-core-pbf-column-content clearfix gdlr-core-js fade-in-left`}
                      >
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                            <div
                              className="gdlr-core-text-box-item-content green_back mirissafont"
                              style={{ fontWeight: 400, letterSpacing: '3px', textTransform: 'none', color: '#eeb85e' }}
                            >
                              <p>
                                Welcome to our luxurious beachside hostel nestled in the serene beauty of Mirissa, Sri Lanka.
                                Immerse yourself in the ultimate fusion of comfort and nature as you unwind in our stylish
                                accommodations. With pristine beaches just steps away, indulge in a blissful escape where every
                                moment is a cherished memory.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                            <a
                              className="gdlr-core-button gdlr-core-button-transparent gdlr-core-left-align"
                              href="/bbmirissa/about"
                              id="gdlr-core-button-id-1"
                            >
                              <span className="gdlr-core-content green_back_second">
                                More About Us
                                <i className="gdlr-core-pos-right icon-arrow-right" style={{ fontSize: '16px', color: '#eeb85e' }}></i>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-30 desktopview" id="gdlr-core-column-3">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div
                        className={`gdlr-core-pbf-column-content clearfix gdlr-core-js fade-in-right`}
                      >
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align" style={{ paddingBottom: '0px' }}>
                            <div
                              className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round2 gdlr-core-image-item-style-round"
                              style={{
                                borderWidth: '0px',
                                maxWidth: '550px',
                                borderRadius: '50px 50px 50px 50px',
                                MozBorderRadius: '50px 50px 50px 50px',
                                WebkitBorderRadius: '50px 50px 50px 50px',
                              }}
                            >
                              <img src={homeImage1} alt="" width="1000" height="1130" title="resort-swim" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-30 allphone" id="gdlr-core-column-3">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div
                        className={`gdlr-core-pbf-column-content clearfix gdlr-core-js fade-in-right`}
                      >
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align" style={{ paddingBottom: '0px' }}>
                            <div
                              className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round2 gdlr-core-image-item-style-round"
                              style={{
                                borderWidth: '0px',
                                maxWidth: '550px',
                                borderRadius: '0px',
                                MozBorderRadius: '0px',
                                WebkitBorderRadius: '0px',
                              }}
                            >
                              <img src={homeMobile} alt="" width="1000" height="1130" title="resort-swim" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-60 desktopview gdlr-core-column-first" id="gdlr-core-column-4">
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js"
                      style={{ margin: '-130px 0px 0px 0px', padding: '0px 0px 0px 0px' }}
                    >
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div
                        className={`gdlr-core-pbf-column-content clearfix gdlr-core-js fade-in-right`}
                      >
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr" style={{ paddingBottom: '0px' }}>
                            <div
                              className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                              style={{ borderWidth: '0px', maxWidth: '1091px' }}
                            >
                              <img src={homeGroup} alt="" width="1381" height="672" title="resort-group" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="outer-container bbmirissabg desktopview">
              <div className="auto-container green_back_second">
                <div className="sec-title centered">
                  <h2
                    className="gdlr-core-title-item-title gdlr-core-skin-title hotale-additional-font class-test"
                    style={{ fontSize: '80px', fontWeight: 400, letterSpacing: '0px', textTransform: 'none', color: '#eeb85e' }}
                  >
                    Rooms & Bunks
                    <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                  </h2>
                  <div className="lower-text">
                    Browse through our range of rooms. A complimentary discount of 25% at Petti Petti Beach Club is offered with
                    all reservations at Banana Bunks Mirissa.
                  </div>
                </div>
              </div>
              <div className="row clearfix" style={{ paddingTop: '40px' }}>
                <div className="column col-xl-4 col-lg-6 col-md-6 col-sm-12">
                  <div
                    className="room-block-one height-two wow fadeInUp"
                    data-wow-delay="300ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="inner-box">
                      <div className="image-box">
                        <div className="image-layer" style={{ backgroundImage: `url(${roomKingIndoor})` }}></div>
                        <figure className="image">
                          <img src={roomKingIndoor} alt="" title="" />
                        </figure>
                      </div>
                      <div className="cap-box">
                        <div className="cap-inner">
                          <h5>Deluxe King Room with Indoor Spa Bath</h5>
                        </div>
                      </div>
                      <div className="hover-box">
                        <div className="hover-inner">
                          <h4>Deluxe King Room with Indoor Spa Bath</h4>
                          <div className="link-box">
                            <a href="/BananaBunksMirissa/room/kingroomwithindoorbath" className="theme-btn btn-style-one">
                              <span className="btn-title">Check Availability</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column col-xl-4 col-lg-6 col-md-6 col-sm-12">
                  <div
                    className="room-block-one height-one wow fadeInUp"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="inner-box">
                      <div className="image-box">
                        <div className="image-layer" style={{ backgroundImage: `url(${roomBunks})` }}></div>
                        <figure className="image">
                          <img src={roomBunks} alt="" title="" />
                        </figure>
                      </div>
                      <div className="cap-box">
                        <div className="cap-inner">
                          <h5>Bed in 6-Bed Mixed Dormitory Room</h5>
                        </div>
                      </div>
                      <div className="hover-box">
                        <div className="hover-inner">
                          <h4>Bed in 6-Bed Mixed Dormitory Room</h4>
                          <div className="link-box">
                            <a href="/BananaBunksMirissa/room/6beddormitory" className="theme-btn btn-style-one">
                              <span className="btn-title">Check Availability</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="room-block-one height-one wow fadeInUp"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="inner-box">
                      <div className="image-box">
                        <div className="image-layer" style={{ backgroundImage: `url(${roomFamily})` }}></div>
                        <figure className="image">
                          <img src={roomFamily} alt="" title="" />
                        </figure>
                      </div>
                      <div className="cap-box">
                        <div className="cap-inner">
                          <h5>Deluxe Family Room</h5>
                        </div>
                      </div>
                      <div className="hover-box">
                        <div className="hover-inner">
                          <h4>Deluxe Family Room</h4>
                          <div className="link-box">
                            <a href="/BananaBunksMirissa/room/deluxefamilyroom" className="theme-btn btn-style-one">
                              <span className="btn-title">Check Availability</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column col-xl-4 col-lg-6 col-md-6 col-sm-12">
                  <div
                    className="room-block-one height-two wow fadeInUp"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="inner-box">
                      <div className="image-box">
                        <div className="image-layer" style={{ backgroundImage: `url(${roomKingOutdoor})` }}></div>
                        <figure className="image">
                          <img src={roomKingOutdoor} alt="" title="" />
                        </figure>
                      </div>
                      <div className="cap-box">
                        <div className="cap-inner">
                          <h5>King Room with Outdoor Spa Bath</h5>
                        </div>
                      </div>
                      <div className="hover-box">
                        <div className="hover-inner">
                          <h4>King Room with Outdoor Spa Bath</h4>
                          <div className="link-box">
                            <a href="/BananaBunksMirissa/room/kingroomwithoutdoorbath" className="theme-btn btn-style-one">
                              <span className="btn-title">Check Availability</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-7">
                <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '40px 0px 40px 0px' }}>
                  <div className="gdlr-core-pbf-background-wrap"></div>
                  <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                    <div className="gdlr-core-pbf-element">
                      <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                        <a
                          className="gdlr-core-button gdlr-core-button-transparent gdlr-core-center-align"
                          href="/bbmirissa/room"
                          style={{
                            fontSize: '13px',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            letterSpacing: '4px',
                            color: '#fff',
                            padding: '15px 0px 10px 0px',
                            textTransform: 'uppercase',
                            borderRadius: '0px',
                            MozBorderRadius: '0px',
                            WebkitBorderRadius: '0px',
                          }}
                        >
                          <span className="gdlr-core-content green_back_second">
                            View All Rooms
                            <i className="gdlr-core-pos-right icon-arrow-right" style={{ fontSize: '16px', color: '#eeb85e' }}></i>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="gdlr-core-pbf-wrapper allphone bbmirissabg" style={{ padding: '90px 0px 0px' }}>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first"
                    style={{ paddingBottom: '25px' }}
                    id="gdlr-core-column-4"
                  >
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-background-wrap green_back_second"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js" style={{ maxWidth: '770px' }}>
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                            id="gdlr-core-title-item-2"
                          >
                            <div className="gdlr-core-title-item-title-wrap green_back_second">
                              <h3
                                className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font"
                                style={{ fontSize: '80px', fontWeight: 500, letterSpacing: '0px', textTransform: 'none' }}
                              >
                                Rooms & Bunks
                                <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                              <div
                                className="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align"
                                style={{ marginBottom: '40px' }}
                              >
                                <div className="gdlr-core-divider-container" style={{ maxWidth: '70px' }}>
                                  <div
                                    className="gdlr-core-divider-line gdlr-core-skin-divider"
                                    style={{
                                      borderColor: '#eeb85e',
                                      borderWidth: '5px',
                                      borderRadius: '0px',
                                      MozBorderRadius: '0px',
                                      WebkitBorderRadius: '0px',
                                    }}
                                  ></div>
                                </div>
                              </div>
                              <div className="lower-text bodyfont">Explore our range of accommodation</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-5">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="tourmaster-room-item clearfix tourmaster-room-item-style-grid2">
                            <div
                              className="gdlr-core-flexslider flexslider gdlr-core-js-2"
                              data-type="carousel"
                              data-column="1"
                              data-move="1"
                              data-nav="navigation-outer"
                              data-nav-parent="self"
                              data-vcenter-nav="1"
                            >
                              <ul className="slides" style={{ paddingLeft: 0 }}>
                                <li className={`gdlr-core-item-mglr ${currentSlide === 0 ? 'active' : ''}`}>
                                  <div className="tourmaster-room-grid2 tourmaster-grid-frame">
                                    <div
                                      className="tourmaster-room-grid-inner"
                                      style={{
                                        borderRadius: '10px',
                                        MozBorderRadius: '10px',
                                        WebkitBorderRadius: '10px',
                                      }}
                                    >
                                      <div className="tourmaster-room-thumbnail tourmaster-media-image">
                                        <a href="/BananaBunksMirissa/room/kingroomwithindoorbath">
                                          <img src={thumbnailKingIndoor} alt="" width="780" height="595" />
                                        </a>
                                      </div>
                                      <div
                                        className="tourmaster-room-content-wrap gdlr-core-skin-e-background gdlr-core-js"
                                        data-sync-height="room-item-56"
                                      >
                                        <h3
                                          className="tourmaster-room-title gdlr-core-skin-title"
                                          style={{ fontSize: '24px', fontWeight: 500, letterSpacing: '0px', textTransform: 'uppercase' }}
                                        >
                                          <a href="/BananaBunksMirissa/room/kingroomwithindoorbath">Deluxe King Room with Indoor Spa Bath</a>
                                        </h3>
                                        <div className="tourmaster-info-wrap clearfix">
                                          <div className="tourmaster-info tourmaster-info-bed-type">
                                            <i className="gdlr-icon-double-bed2"></i>
                                            <span className="tourmaster-tail">1 King Bed</span>
                                          </div>
                                          <div className="tourmaster-info tourmaster-info-guest-amount">
                                            <i className="gdlr-icon-group"></i>
                                            <span className="tourmaster-tail">2 Guests</span>
                                          </div>
                                        </div>
                                        <div className="tourmaster-bottom clearfix">
                                          <a
                                            className="tourmaster-read-more tourmaster-type-button"
                                            href="/BananaBunksMirissa/room/kingroomwithindoorbath"
                                          >
                                            Book Now
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li className={`gdlr-core-item-mglr ${currentSlide === 1 ? 'active' : ''}`}>
                                  <div className="tourmaster-room-grid2 tourmaster-grid-frame">
                                    <div
                                      className="tourmaster-room-grid-inner"
                                      style={{
                                        borderRadius: '10px',
                                        MozBorderRadius: '10px',
                                        WebkitBorderRadius: '10px',
                                      }}
                                    >
                                      <div className="tourmaster-room-thumbnail tourmaster-media-image tourmaster-with-ribbon">
                                        <a href="/BananaBunksMirissa/room/kingroomwithoutdoorbath">
                                          <img src={thumbnailKingOutdoor} alt="" width="780" height="595" />
                                        </a>
                                      </div>
                                      <div
                                        className="tourmaster-room-content-wrap gdlr-core-skin-e-background gdlr-core-js"
                                        data-sync-height="room-item-56"
                                      >
                                        <h3
                                          className="tourmaster-room-title gdlr-core-skin-title"
                                          style={{ fontSize: '24px', fontWeight: 500, letterSpacing: '0px', textTransform: 'uppercase' }}
                                        >
                                          <a href="/BananaBunksMirissa/room/kingroomwithoutdoorbath">Deluxe King Room with Outdoor Spa Bath</a>
                                        </h3>
                                        <div className="tourmaster-info-wrap clearfix">
                                          <div className="tourmaster-info tourmaster-info-bed-type">
                                            <i className="gdlr-icon-double-bed2"></i>
                                            <span className="tourmaster-tail">1 Large Bed & 1 Single Bed</span>
                                          </div>
                                          <div className="tourmaster-info tourmaster-info-guest-amount">
                                            <i className="gdlr-icon-group"></i>
                                            <span className="tourmaster-tail">2 Guests</span>
                                          </div>
                                        </div>
                                        <div className="tourmaster-bottom clearfix">
                                          <a
                                            className="tourmaster-read-more tourmaster-type-button"
                                            href="/BananaBunksMirissa/room/kingroomwithoutdoorbath"
                                          >
                                            Book Now
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li className={`gdlr-core-item-mglr ${currentSlide === 2 ? 'active' : ''}`}>
                                  <div className="tourmaster-room-grid2 tourmaster-grid-frame">
                                    <div
                                      className="tourmaster-room-grid-inner"
                                      style={{
                                        borderRadius: '10px',
                                        MozBorderRadius: '10px',
                                        WebkitBorderRadius: '10px',
                                      }}
                                    >
                                      <div className="tourmaster-room-thumbnail tourmaster-media-image">
                                        <a href="/BananaBunksMirissa/room/deluxefamilyroom">
                                          <img src={thumbnailFamily} alt="" width="780" height="595" />
                                        </a>
                                      </div>
                                      <div
                                        className="tourmaster-room-content-wrap gdlr-core-skin-e-background gdlr-core-js"
                                        data-sync-height="room-item-56"
                                      >
                                        <h3
                                          className="tourmaster-room-title gdlr-core-skin-title"
                                          style={{ fontSize: '24px', fontWeight: 500, letterSpacing: '0px', textTransform: 'uppercase' }}
                                        >
                                          <a href="/BananaBunksMirissa/room/deluxefamilyroom">Deluxe Family Room With 3 Beds</a>
                                        </h3>
                                        <div className="tourmaster-info-wrap clearfix">
                                          <div className="tourmaster-info tourmaster-info-bed-type">
                                            <i className="gdlr-icon-double-bed2"></i>
                                            <span className="tourmaster-tail">3 Double Beds</span>
                                          </div>
                                          <div className="tourmaster-info tourmaster-info-guest-amount">
                                            <i className="gdlr-icon-group"></i>
                                            <span className="tourmaster-tail">6 Guests</span>
                                          </div>
                                        </div>
                                        <div className="tourmaster-bottom clearfix">
                                          <a
                                            className="tourmaster-read-more tourmaster-type-button"
                                            href="/BananaBunksMirissa/room/deluxefamilyroom"
                                          >
                                            Book Now
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li className={`gdlr-core-item-mglr ${currentSlide === 3 ? 'active' : ''}`}>
                                  <div className="tourmaster-room-grid2 tourmaster-grid-frame">
                                    <div
                                      className="tourmaster-room-grid-inner"
                                      style={{
                                        borderRadius: '10px',
                                        MozBorderRadius: '10px',
                                        WebkitBorderRadius: '10px',
                                      }}
                                    >
                                      <div className="tourmaster-room-thumbnail tourmaster-media-image">
                                        <a href="/BananaBunksMirissa/room/6beddormitory">
                                          <img src={thumbnailBunks} alt="" width="780" height="595" />
                                        </a>
                                      </div>
                                      <div
                                        className="tourmaster-room-content-wrap gdlr-core-skin-e-background gdlr-core-js"
                                        data-sync-height="room-item-56"
                                      >
                                        <h3
                                          className="tourmaster-room-title gdlr-core-skin-title"
                                          style={{ fontSize: '24px', fontWeight: 500, letterSpacing: '0px', textTransform: 'uppercase' }}
                                        >
                                          <a href="/BananaBunksMirissa/room/6beddormitory">Bed in 6-Bed Mixed Dormitory Room</a>
                                        </h3>
                                        <div className="tourmaster-info-wrap clearfix">
                                          <div className="tourmaster-info tourmaster-info-bed-type">
                                            <i className="gdlr-icon-double-bed2"></i>
                                            <span className="tourmaster-tail">6 Bunk Beds</span>
                                          </div>
                                          <div className="tourmaster-info tourmaster-info-guest-amount">
                                            <i className="gdlr-icon-group"></i>
                                            <span className="tourmaster-tail">6 Guests</span>
                                          </div>
                                        </div>
                                        <div className="tourmaster-bottom clearfix">
                                          <a
                                            className="tourmaster-read-more tourmaster-type-button"
                                            href="/BananaBunksMirissa/room/6beddormitory"
                                          >
                                            Book Now
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-center-align" style={{ paddingBottom: '30px' }}>
                            <a
                              className="gdlr-core-button gdlr-core-button-transparent gdlr-core-center-align gdlr-core-button-with-border"
                              href="/bbmirissa/room"
                              style={{
                                fontSize: '18px',
                                fontStyle: 'normal',
                                fontWeight: 500,
                                letterSpacing: '0px',
                                color: '#585550',
                                padding: '9px 33px 9px 33px',
                                textTransform: 'uppercase',
                                borderRadius: '5px',
                                MozBorderRadius: '5px',
                                WebkitBorderRadius: '5px',
                                borderWidth: '2px 2px 2px 2px',
                                backgroundColor: '#eeb85e',
                                borderColor: '#eeb85e',
                              }}
                            >
                              <span className="gdlr-core-content">View All Rooms</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="gdlr-core-pbf-wrapper videopadding" id="gdlr-core-wrapper-6">
              <div className="gdlr-core-pbf-background-wrap">
                <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js">
                  <img className="vid_pic" src={videoThumbnail} alt="" />
                </div>
              </div>
            </div>

            <div className="gdlr-core-pbf-wrapper secspacing bbmirissabg" id="gdlr-core-wrapper-6">
              <div className="gdlr-core-pbf-background-wrap"></div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div className="gdlr-core-pbf-element bbkandybg">
                    <div
                      className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                      id="gdlr-core-title-item-2"
                    >
                      <div className="gdlr-core-title-item-title-wrap green_back_second">
                        <h3
                          className="gdlr-core-title-item-title gdlr-core-skin-title hotale-additional-font class-test"
                          style={{ fontFamily: 'boogaloo', fontSize: '80px', fontWeight: 400, letterSpacing: '0px', textTransform: 'none' }}
                        >
                          Make every moment count
                          <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                        </h3>
                        <div className="lower-text">
                          Together with our restaurant Petti Petti Mirissa, we offer a range of activities and lounge spaces for
                          the most scenic vacation
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="gdlr-core-pbf-wrapper bbmirissabg" style={{ padding: '0px 0px 63px 0px' }} id="gdlr-core-wrapper-7">
              <div className="gdlr-core-pbf-background-wrap"></div>
              <div className="gdlr-core-pbf-background-wrap" style={{ top: '-10px' }}>
                <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" data-parallax-speed="0.1"></div>
              </div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div className="gdlr-core-pbf-column gdlr-core-column-36 gdlr-core-column-first" id="gdlr-core-column-20">
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js"
                      style={{
                        borderRadius: '20px 20px 20px 20px',
                        MozBorderRadius: '20px 20px 20px 20px',
                        WebkitBorderRadius: '20px 20px 20px 20px',
                      }}
                    >
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                            style={{ paddingBottom: '0px' }}
                          >
                            <div
                              className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round"
                              style={{
                                borderWidth: '0px',
                                borderRadius: '20px',
                                MozBorderRadius: '20px',
                                WebkitBorderRadius: '20px',
                              }}
                            >
                              <img src={pettiImage} alt="" width="1300" height="716" title="chef-cook" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="gdlr-core-pbf-column gdlr-core-column-24" id="gdlr-core-column-21">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js facipadding">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div
                        className="gdlr-core-pbf-column-content clearfix gdlr-core-js green_back_second content-visible"
                        data-gdlr-animation="fadeInRight"
                        data-gdlr-animation-duration="600ms"
                        data-gdlr-animation-offset="0.8"
                      >
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                            style={{ paddingBottom: '35px' }}
                          >
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3
                                className="gdlr-core-title-item-title gdlr-core-skin-title class-test greencolor"
                                style={{ fontSize: '30px', fontWeight: 500, letterSpacing: '0px', lineHeight: 1.6, textTransform: 'none' }}
                              >
                                Specials Offers
                                <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                            style={{ paddingBottom: '20px' }}
                          >
                            <div
                              className="gdlr-core-text-box-item-content"
                              style={{ fontSize: '18px', fontWeight: 400, textTransform: 'none' }}
                            >
                              <p>
                                In-house guests at Banana Bunks gets 25% off on all food and non-alcoholic beverages at our
                                restaurant! It’s a great way to explore Petti Petti’s flavor packed menu.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="gdlr-core-pbf-column gdlr-core-column-36 allphone" id="gdlr-core-column-23">
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js"
                      style={{
                        margin: '40px 0px 0px 0px',
                        borderRadius: '20px 20px 20px 20px',
                        MozBorderRadius: '20px 20px 20px 20px',
                        WebkitBorderRadius: '20px 20px 20px 20px',
                      }}
                    >
                      <div
                        className="gdlr-core-pbf-background-wrap"
                        style={{
                          borderRadius: '20px 20px 20px 20px',
                          MozBorderRadius: '20px 20px 20px 20px',
                          WebkitBorderRadius: '20px 20px 20px 20px',
                        }}
                      >
                        <div
                          className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                          style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}
                          data-parallax-speed="0"
                        ></div>
                      </div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                            style={{ paddingBottom: '0px' }}
                          >
                            <div
                              className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round"
                              style={{
                                borderWidth: '0px',
                                borderRadius: '20px',
                                MozBorderRadius: '20px',
                                WebkitBorderRadius: '20px',
                              }}
                            >
                              <img src={loungeImage} alt="" width="1300" height="716" title="bar" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-24 gdlr-core-column-first" id="gdlr-core-column-22">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js poolpadding">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div
                        className="gdlr-core-pbf-column-content clearfix gdlr-core-js green_back_second content-visible"
                        data-gdlr-animation="fadeInLeft"
                        data-gdlr-animation-duration="600ms"
                        data-gdlr-animation-offset="0.8"
                      >
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3
                                className="gdlr-core-title-item-title gdlr-core-skin-title class-test greencolor"
                                style={{ fontSize: '30px', fontWeight: 500, letterSpacing: '0px', lineHeight: 1.6, textTransform: 'none' }}
                              >
                                Lounge Area
                                <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                            style={{ paddingBottom: '20px' }}
                          >
                            <div
                              className="gdlr-core-text-box-item-content"
                              style={{ fontSize: '18px', fontWeight: 400, textTransform: 'none' }}
                            >
                              <p>
                                Looking for a hang-out spot?
                                <br />
                                Our lounge area doubles as chill spot and work-space for guests who are working on the go.
                                Shaded using local hay, the lounge sets the scene for all travelers!
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="gdlr-core-pbf-column gdlr-core-column-36 desktopview" id="gdlr-core-column-23">
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js"
                      style={{
                        margin: '110px 0px 0px 0px',
                        borderRadius: '20px 20px 20px 20px',
                        MozBorderRadius: '20px 20px 20px 20px',
                        WebkitBorderRadius: '20px 20px 20px 20px',
                      }}
                    >
                      <div
                        className="gdlr-core-pbf-background-wrap"
                        style={{
                          borderRadius: '20px 20px 20px 20px',
                          MozBorderRadius: '20px 20px 20px 20px',
                          WebkitBorderRadius: '20px 20px 20px 20px',
                        }}
                      >
                        <div
                          className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                          style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}
                          data-parallax-speed="0"
                        ></div>
                      </div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                            style={{ paddingBottom: '0px' }}
                          >
                            <div
                              className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round"
                              style={{
                                borderWidth: '0px',
                                borderRadius: '20px',
                                MozBorderRadius: '20px',
                                WebkitBorderRadius: '20px',
                              }}
                            >
                              <img src={loungeImage} alt="" width="1300" height="716" title="bar" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="gdlr-core-pbf-wrapper hotelcontain bbmirissabg" id="gdlr-core-wrapper-8" ref={facilitiesRef}>
              <div className="gdlr-core-pbf-wrapper" style={{ paddingTop: 0 }} id="gdlr-core-wrapper-4">
                <div className="gdlr-core-pbf-background-wrap" style={{ top: '30px' }}>
                  <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"></div>
                </div>
                <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                  <div
                    className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container-custom green_back_second"
                    style={{ maxWidth: '1000px' }}
                  >
                    <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
                      <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                        <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                          <div className="gdlr-core-pbf-element">
                            <div
                              className="gdlr-core-title-item clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                              id="gdlr-core-title-item-3"
                            >
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title hotale-additional-font class-test"
                                  style={{ fontSize: '80px', fontWeight: 400, letterSpacing: '0px', textTransform: 'none', color: '#eeb85e' }}
                                >
                                  Hotel Facilities
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-8">
                      <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '0px 0px 50px 0px' }}>
                        <div className="gdlr-core-pbf-background-wrap"></div>
                        <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js" style={{ maxWidth: '760px' }}>
                          <div className="gdlr-core-pbf-element">
                            <div
                              className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align gdlr-core-no-p-space"
                              style={{ paddingBottom: '0px' }}
                            >
                              <div
                                className="gdlr-core-text-box-item-content"
                                style={{ fontSize: '21px', fontWeight: 400, letterSpacing: '0px', textTransform: 'none', color: '#eeb85e' }}
                              >
                                <p>Relax, indulge, and savor our luxurious hotel amenities to unwind.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="gdlr-core-pbf-column gdlr-core-column-12 gdlr-core-column-first" id="gdlr-core-column-9">
                      <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                        <div className="gdlr-core-pbf-background-wrap"></div>
                        <div
                          className="gdlr-core-pbf-column-content clearfix gdlr-core-js pbottom"
                          data-gdlr-animation="fadeInUp"
                          data-gdlr-animation-duration="600ms"
                          data-gdlr-animation-offset="0.8"
                        >
                          <div className="gdlr-core-pbf-element">
                            <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr">
                              <div
                                className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                                style={{ borderWidth: '0px', maxWidth: '76px' }}
                              >
                                <img src={group40} alt="" width="130" height="110" title="Group 40" />
                              </div>
                            </div>
                          </div>
                          <div className="gdlr-core-pbf-element">
                            <div
                              className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                              style={{ paddingBottom: '0px' }}
                            >
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{ fontSize: '20px', fontWeight: 500, letterSpacing: '0px', textTransform: 'none' }}
                                >
                                  Parking
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="gdlr-core-pbf-column gdlr-core-column-12" id="gdlr-core-column-11">
                      <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                        <div className="gdlr-core-pbf-background-wrap"></div>
                        <div
                          className="gdlr-core-pbf-column-content clearfix gdlr-core-js pbottom"
                          data-gdlr-animation="fadeInUp"
                          data-gdlr-animation-duration="600ms"
                          data-gdlr-animation-offset="0.8"
                        >
                          <div className="gdlr-core-pbf-element">
                            <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                              <i
                                className="gdlr-core-icon-item-icon gdlr-icon-swimming-pool1"
                                style={{ color: '#eeb85e', fontSize: '62px', minWidth: '62px', minHeight: '64px' }}
                              ></i>
                            </div>
                          </div>
                          <div className="gdlr-core-pbf-element">
                            <div
                              className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                              style={{ paddingBottom: '0px' }}
                            >
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{ fontSize: '20px', fontWeight: 500, letterSpacing: '0px', textTransform: 'none' }}
                                >
                                  Swimming Pool                                  
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="gdlr-core-pbf-column gdlr-core-column-12" id="gdlr-core-column-12">
                      <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                        <div className="gdlr-core-pbf-background-wrap"></div>
                        <div
                          className="gdlr-core-pbf-column-content clearfix gdlr-core-js"
                          data-gdlr-animation="fadeInDown"
                          data-gdlr-animation-duration="600ms"
                          data-gdlr-animation-offset="0.8"
                        >
                          <div className="gdlr-core-pbf-element">
                            <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                              <i
                                className="gdlr-core-icon-item-icon gdlr-icon-wifi-signal"
                                style={{ color: '#eeb85e', fontSize: '65px', minWidth: '65px', minHeight: '65px' }}
                              ></i>
                            </div>
                          </div>
                          <div className="gdlr-core-pbf-element">
                            <div
                              className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                              style={{ paddingBottom: '0px' }}
                            >
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{ fontSize: '20px', fontWeight: 500, letterSpacing: '0px', textTransform: 'none' }}
                                >
                                  Wifi
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="gdlr-core-pbf-column gdlr-core-column-12" id="gdlr-core-column-16">
                      <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                        <div className="gdlr-core-pbf-background-wrap"></div>
                        <div
                          className="gdlr-core-pbf-column-content clearfix gdlr-core-js"
                          data-gdlr-animation="fadeInUp"
                          data-gdlr-animation-duration="600ms"
                          data-gdlr-animation-offset="0.8"
                        >
                          <div className="gdlr-core-pbf-element">
                            <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                              <i
                                className="gdlr-core-icon-item-icon gdlr-icon-breakfast"
                                style={{ color: '#eeb85e', fontSize: '65px', minWidth: '65px', minHeight: '65px' }}
                              ></i>
                            </div>
                          </div>
                          <div className="gdlr-core-pbf-element">
                            <div
                              className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                              style={{ paddingBottom: '0px' }}
                            >
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{ fontSize: '20px', fontWeight: 500, letterSpacing: '0px', textTransform: 'none' }}
                                >
                                  Breakfast
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="gdlr-core-pbf-column gdlr-core-column-12" id="gdlr-core-column-17">
                      <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                        <div className="gdlr-core-pbf-background-wrap"></div>
                        <div
                          className="gdlr-core-pbf-column-content clearfix gdlr-core-js"
                          data-gdlr-animation="fadeInUp"
                          data-gdlr-animation-duration="600ms"
                          data-gdlr-animation-offset="0.8"
                        >
                          <div className="gdlr-core-pbf-element">
                            <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr">
                              <div
                                className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                                style={{ borderWidth: '0px', maxWidth: '76px' }}
                              >
                                <img src={loungeIcon} alt="" width="130" height="110" title="Group 40" />
                              </div>
                            </div>
                          </div>
                          <div className="gdlr-core-pbf-element">
                            <div
                              className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                              style={{ paddingBottom: '0px' }}
                            >
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{ fontSize: '20px', fontWeight: 500, letterSpacing: '0px', textTransform: 'none' }}
                                >
                                  Lounge Area
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Home;